import { CompareActionTypes, ProductGroupActionTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { toggleComparedStateForItems } from '../../../redux/compare/reducers/CompareReducer';
import { updateWishListProducts, initializeWishListProducts } from '../../../redux/wishList/reducers/WishListReducer';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
export const loadProductGroupReducer = (initialData = null) => {
    var _a;
    const initialProductGroupState = (initialData === null || initialData === void 0 ? void 0 : initialData.productGroupId)
        ? { [initialData.productGroupId]: (_a = initialData.products) !== null && _a !== void 0 ? _a : [] }
        : {};
    return (state = initialProductGroupState, action) => {
        var _a;
        switch (action.type) {
            case CompareActionTypes.COMPARE_UPDATE_PRODUCTS: {
                const newProductGroupItemsList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsList[key] = toggleComparedStateForItems(state[key], action.payload);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsList);
            }
            case WishListActionTypes.UPDATE_PRODUCTS: {
                const newProductGroupItemsForUpdateWishList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsForUpdateWishList[key] = initializeWishListProducts(state[key], action);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsForUpdateWishList);
            }
            case WishListActionTypes.ADD_PRODUCT: {
                const newProductGroupItemsForAddWishList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsForAddWishList[key] = updateWishListProducts(state[key], action, true);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsForAddWishList);
            }
            case WishListActionTypes.REMOVE_PRODUCT: {
                const newProductGroupItemsForRemoveWishList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsForRemoveWishList[key] = updateWishListProducts(state[key], action, false);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsForRemoveWishList);
            }
            case ProductGroupActionTypes.SET_DELIVERY_PROMISE: {
                const { productGroupId } = action.payload;
                if (!productGroupId)
                    return state;
                return Object.assign(Object.assign({}, state), { [productGroupId]: setDeliveryPromiseToProducts((_a = state[productGroupId]) !== null && _a !== void 0 ? _a : [], action.payload) });
            }
            case ProductGroupActionTypes.SET_PRODUCT_GROUPS:
                return Object.assign(Object.assign({}, state), action.payload);
            default:
                return state;
        }
    };
};
export const productGroupReducer = loadProductGroupReducer();
